export const GET_CIRCLES = 'GET_CIRCLES';// 获取圈子列表

export const GET_CIRCLE = 'GET_CIRCLE';// 获取圈子信息

export const UPDATE_CIRCLE = 'UPDATE_CIRCLE';

export const DELETE_CIRCLE = 'DELETE_CIRCLE';

export const CREATE_CIRCLE = 'CREATE_CIRCLE';// 创建圈子